exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".react-phone-number-input__row {\n  flex-wrap: wrap;\n}\n\n.react-phone-number-input__icon {\n  position: relative;\n}\n\n.react-phone-number-input__icon-image {\n  position: absolute;\n  top: 0;\n}", ""]);

